import React from 'react';
import { Box } from '@mui/material';
import { useAtomValue } from 'jotai';
import { searchValuesAtom } from '../../Atoms';
import useTranslate from '../../Hooks/useTranslate';
import FiltersSelection from '../Filters/FiltersSelection';
import BottomSheet from './BottomSheet';

/**
 * FilterSheet — bottom sheet wrapping the desktop FiltersSelection so the
 * mobile Contatti tab shares the exact same filters (they persist to
 * searchValuesAtom). The desktop 35vw two-column layout is stacked full-width;
 * the Azzera/Conferma actions live in FiltersSelection's sticky footer.
 *
 * `customFilters` replaces the panel for a section whose filters come from a
 * layout, the way FiltersButton does on desktop; the stacking below applies to
 * either, so a layout-driven panel needs nothing of its own.
 */
const FilterSheet = function FilterSheet({
  open = false,
  onClose = () => {},
  currentSection = 'CUSTOMERS',
  showWaveFilters = false,
  customFilters = null,
  filtersLayout = null,
}) {
  const translate = useTranslate();
  const searchValues = useAtomValue(searchValuesAtom);

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title={translate('FILTERS')}
      closable
      maxHeight="92%"
    >
      <Box
        className="scr"
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          // Stack the desktop 35vw two-column FiltersSelection full-width.
          '& > div:first-of-type': {
            width: '100% !important',
            flexDirection: 'column',
            gap: '16px !important',
            p: '4px 16px',
          },
          '& .MuiStack-root': { width: '100% !important' },
        }}
      >
        {/* The panel closes the sheet when it is done, as it closes the dialog on desktop, so the
            sheet hands it the way out rather than each caller remembering to. */}
        {React.isValidElement(customFilters) ? (
          React.cloneElement(customFilters, { onClose })
        ) : (
          <FiltersSelection
            currentSection={currentSection}
            showWaveFilters={showWaveFilters}
            layout={filtersLayout}
            defaultFilters={searchValues ?? {}}
            closeMenu={onClose}
          />
        )}
      </Box>
    </BottomSheet>
  );
};

export default FilterSheet;
